import { render } from "./ModalDetalhesTarefas.vue?vue&type=template&id=16988d16&scoped=true"
import script from "./ModalDetalhesTarefas.vue?vue&type=script&lang=js"
export * from "./ModalDetalhesTarefas.vue?vue&type=script&lang=js"

import "./ModalDetalhesTarefas.vue?vue&type=style&index=0&id=16988d16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16988d16"]])

export default __exports__